'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CommentInput = require('./CommentInput');

var _CommentInput2 = _interopRequireDefault(_CommentInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Note = function (_React$Component) {
	_inherits(Note, _React$Component);

	function Note(props) {
		_classCallCheck(this, Note);

		var _this = _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).call(this, props));

		_this.state = {
			showInput: false
		};

		_this.toggleShowInput = _this._toggleShowInput.bind(_this);
		return _this;
	}

	_createClass(Note, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    id = _props.id,
			    author = _props.author,
			    time = _props.time,
			    message = _props.message,
			    onSubmitComment = _props.onSubmitComment,
			    onClickDelete = _props.onClickDelete,
			    parent_id = _props.parent_id;


			var d = new Date(time);
			var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

			var dateString = d.getDate() + '. ' + monthNames[d.getMonth()] + ', ' + d.getFullYear();

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("note", { indent: false }) },
				_react2.default.createElement(
					'div',
					{ className: 'section' },
					_react2.default.createElement('div', { className: 'image', style: { backgroundImage: 'url(' + author.image + ')' } }),
					_react2.default.createElement(
						'div',
						{ className: 'content' },
						_react2.default.createElement(
							'div',
							{ className: 'header' },
							author.id == CURRENT_USER.id && _react2.default.createElement(
								'div',
								{ className: 'pull-right ix ix-delete', onClick: onClickDelete },
								'Delete'
							),
							_react2.default.createElement(
								'span',
								{ className: 'author' },
								author.name
							),
							_react2.default.createElement(
								'span',
								{ className: 'date' },
								dateString
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'message' },
							message
						)
					)
				)
			);
		}
	}, {
		key: '_toggleShowInput',
		value: function _toggleShowInput() {
			this.setState({
				showInput: !this.state.showInput
			});
		}
	}]);

	return Note;
}(_react2.default.Component);

exports.default = Note;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/notes/Note.js
// module id = 583
// module chunks = 0